export enum Permission {
  canAccessInsightsPageTravel = 'canAccessInsightsPageTravel',
  canAccessInsightsPageMobility = 'canAccessInsightsPageMobility',
  canViewTravelCases = 'canViewTravelCases',
  canViewMobilityCases = 'canViewMobilityCases',
  canAccessEconomyPageMobility = 'canAccessEconomyPageMobility',
  canAccessEconomyPageTravel = 'canAccessEconomyPageTravel'
}
